module.exports = __webpack_public_path__ + "img/user-nav-jrdj-icon.16a29bb9.png";